<div class="sprintpay-footer sticky-bottom justify-content-md-center">
    <ng-content />
</div>
